var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPatient(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    stroke: "currentColor",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6667 25.3332V23.2591C26.6667 20.9681 24.8215 19.1109 22.5455 19.1109H22.0303M18.4242 14.9628C20.7003 14.9628 22.5455 13.1056 22.5455 10.8147C22.5455 8.52369 20.7003 6.6665 18.4242 6.6665M20.4848 25.3332V23.2591C20.4848 20.9681 18.6397 19.1109 16.3636 19.1109H8.12121C5.84513 19.1109 4 20.9681 4 23.2591V25.3332M16.3636 10.8147C16.3636 13.1056 14.5185 14.9628 12.2424 14.9628C9.96634 14.9628 8.12121 13.1056 8.12121 10.8147C8.12121 8.52369 9.96634 6.6665 12.2424 6.6665C14.5185 6.6665 16.3636 8.52369 16.3636 10.8147Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPatient);
export default __webpack_public_path__ + "static/media/icon-patient.d606e4a4.svg";
export { ForwardRef as ReactComponent };